import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const CtaI3 = ({
  key,
  heading=null,
  solidBackgroundColor="white",
  content=null,
  link=null,
  linkText=null
}) => {
  return (
    <div className={ `cta_block cta-i3 tcw before-${solidBackgroundColor}` }>
      <div className="container">
        <div className="row ph1">
          <div className="w-100 d-flex justify-content-center bs1 cta-gradient-bg">
            <div className="col-12 col-md-10 col-lg-7 text-center pv8">
              {heading &&
                <h2 className="text-center tcw pv1.2 ph1.2 ft10">{ htmlDecode(heading) }</h2>
              }
              {content &&
              <p>{ htmlDecode(content) }</p>
              }
              {link && linkText &&
                <Link href={ link } className="button">{ linkText }</Link>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CtaI3
